import moment from 'moment';

import { OfferHeader } from '../../../models/offer';
import { UNDERSCORE } from '../../../../shared/utils/constant';
import { getParseDate, getFormatDate, formatInterval } from '../../../../shared/utils/resolved-format-date';

function formatIsoMonth(month: string) {
	return moment(
		month,
		getParseDate('isoMonth')
	).format(
		getFormatDate('month')
	);
}

export function createOfferPeriod(header: OfferHeader) {
	const { periodStartMonth, periodEndMonth } = header;
	if (!periodStartMonth || !periodEndMonth) {
		return UNDERSCORE;
	}
	return formatInterval(formatIsoMonth(periodStartMonth), formatIsoMonth(periodEndMonth));
}
